import React from "react";

// Component created following the React documentation website
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.group("ErrorCatch");
    console.info(error);
    console.info(info);
    console.error(info.componentStack);
    console.groupEnd();
  }

  render() {
    if (this.state.hasError) {
      // Rendering the custom fallback UI
      return this.props.fallback;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
